<template>
	<ValidationProvider
		ref="provider"
		:vid="`${computedName}-${generatedId}`"
		:name="options.label"
		:rules="options.rules"
		v-slot="{ errors, classes }"
		slim
	>
		<label class="select-label d-table w-100 text-center" v-if="options.sidebar">{{ options.label }}</label>
		<div :class="[options.wrapperClass, { 'mb-8px': errors[0] === undefined }]">
			<span :class="computedClasses(classes)">
				<input
					type="text"
					:value="getData()"
					@input="setData($event.target.value)"
					@keyup="handleKeyup"
					@focus="handleFocus"
					@blur="handleBlur"
					:id="generatedId"
					:name="name"
					:class="options.className"
					:placeholder="options.label"
					autocomplete="disabled"
					data-hj-allow
				/>
				<div class="results" v-show="showResults">
					<ul>
						<li v-for="(choice, index) in results" :key="index" @mousedown="handleClick($event, choice)">
							{{ choice[options.field.text] }}
						</li>
					</ul>
				</div>
			</span>
			<span
				:class="['error_message error_message--broke', options.className, { 'mb-8px': type === 'contracting' }]"
				v-if="errors[0]"
			>
				{{ errors[0] }}
			</span>
		</div>
	</ValidationProvider>
</template>

<script>
import shared from '@/mixins/shared';
import _ from 'lodash';

export default {
	mixins: [shared],
	data() {
		return {
			showResults: false,
			results: null,
		};
	},
	computed: {
		computedClasses() {
			return classes => {
				return _.has(this.options, 'novalidate')
					? ['w-100 select-arrow', this.options.className]
					: ['w-100 select-arrow', this.options.className, classes];
			};
		},
	},
	methods: {
		handleFocus() {
			if (this.results === null) {
				this.results = this.options.choices;
			}

			this.showResults = true;
		},
		handleBlur(event) {
			event.preventDefault();
			event.stopPropagation();

			this.showResults = false;
		},
		handleKeyup(e) {
			this.showResults = true;
			this.results = this.search(e.target.value);
		},
		handleClick(event, choice) {
			event.preventDefault();
			event.stopPropagation();

			this.setData(choice[this.options.field.text]);
			this.$emit('click', choice[this.options.field.value]);
			this.showResults = false;
		},
		search(value) {
			return this.options.choices.filter(
				choice => choice[this.options.field.text].toLowerCase().indexOf(value.toLowerCase()) > -1,
			);

			let results = {};

			_.each(this.options.choices, (choice, index) => {
				if (choice[this.options.field.text].toLowerCase().indexOf(value.toLowerCase()) > -1) {
					_.assign(results, { [index]: choice });
				}
			});

			return results;
		},
	},
};
</script>

<style lang="scss" scoped>
.select-arrow {
	position: relative;
}

.results {
	max-height: 250px;
	overflow: auto;
	position: absolute;
	top: 30px;
	left: 0;
	right: 0;
	background: white;
	z-index: 99;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;

	ul {
		padding: 0;
		margin: 0;
		list-style-type: none;

		li {
			padding: 5px 10px;
			cursor: pointer;
		}
	}
}
</style>
